import { ONE_MINUTE, ONE_HOUR, ONE_DAY, ONE_WEEK } from '@gem/services/date-service';

import { getUnitLabel } from 'APP/utils/calendar/getHumanizeRRule';

export const getCustomReminderTitle = (initialTime: number): string => {
  const timeMap = {
    week: ONE_WEEK / ONE_MINUTE,
    day: ONE_DAY / ONE_MINUTE,
    hour: ONE_HOUR / ONE_MINUTE,
    minute: ONE_MINUTE / ONE_MINUTE,
  } as const;

  const timeComponents: Array<{ key: string; value: number }> = [];
  let time = initialTime;

  for (const key in timeMap) {
    const currentTimeDimension = timeMap[key as keyof typeof timeMap];
    const timeInteger = Math.trunc(time / currentTimeDimension);
    if (timeInteger > 0) {
      timeComponents.push({ key, value: timeInteger });
      time -= timeInteger * currentTimeDimension;
    }
  }

  const result = timeComponents.map((timeComponent) => {
    return timeComponent.value + ' ' + getUnitLabel(timeComponent.value, timeComponent.key);
  });

  return result.join(', ');
};
